exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-donate-tsx": () => import("./../../../src/pages/donate.tsx" /* webpackChunkName: "component---src-pages-donate-tsx" */),
  "component---src-templates-generic-page-tsx": () => import("./../../../src/templates/GenericPage.tsx" /* webpackChunkName: "component---src-templates-generic-page-tsx" */),
  "component---src-templates-news-article-page-tsx": () => import("./../../../src/templates/NewsArticlePage.tsx" /* webpackChunkName: "component---src-templates-news-article-page-tsx" */)
}

